import { render, staticRenderFns } from "./PrevisionDetail.vue?vue&type=template&id=cda49368&lang=pug&"
import script from "./PrevisionDetail.vue?vue&type=script&lang=js&"
export * from "./PrevisionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrevisionDetail.vue"
export default component.exports